import React from 'react';
import { NotificationContainer } from 'react-notifications';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import HeaderComponent from './components/header';
import MainContainer from './components/main-container';
import 'react-notifications/lib/notifications.css';

export default function App() {
  const pathname = (useLocation().pathname ?? '/').replace(/\/$/, '') || '/';
  const isAuthRoute = pathname === '/login' || pathname === '/signup';
  const isFestivalViewRoute = /^\/festival\/[^/]+\/view$/.test(pathname);

  const withSideNav = !isAuthRoute && !isFestivalViewRoute;
  const withHeader = !isAuthRoute;

  return (
    <div
      className={cn(
        'bethere-bg flex min-h-screen flex-col font-sans antialiased',
        isAuthRoute && 'bethere-auth-page',
      )}
    >
      <HeaderComponent withHeader={withHeader} />
      <MainContainer withSideNav={withSideNav} isAuthRoute={isAuthRoute} />
      <NotificationContainer />
    </div>
  );
}
